var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"video",staticStyle:{"display":"none"},attrs:{"src":_vm.videoSrc},on:{"loadeddata":_vm.captureFrame}}),_c('canvas',{ref:"canvas",staticClass:"canvas"}),(_vm.previewDataUrl)?_c('img',{attrs:{"src":_vm.previewDataUrl,"alt":"Video Preview"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }